import React from "react";

const isOnvoDomain = (url) => {
  try {
    const parsedUrl = new URL(url);
    return parsedUrl.hostname.indexOf("onvo") > -1;
  } catch (e) {}
  return true;
};

const Link = ({ className, href, title, onClick, children, id }) => {
  return href ? (
    <a
      id={id}
      className={className}
      title={title}
      href={href}
      onClick={onClick}
      target={isOnvoDomain(href) ? undefined : "_blank"}
      rel={isOnvoDomain(href) ? undefined : "noopener noreferrer"}
    >
      {children || title}
    </a>
  ) : (
    <span id={id} className={className} onClick={onClick}>
      {children || title}
    </span>
  );
};

export default Link;
